import {
	moduleName,
	checkAnotherUser,
} from './index'


export default {
	[moduleName + checkAnotherUser.response_type]: checkAnotherUser.reducer,
}
